import React from 'react';
import { Button } from '@/components/ui/button';
import GlassPill from '@/components/ui/GlassPill';
import { AlertTriangle, RefreshCw } from 'lucide-react';

interface LoadingErrorProps {
  errorMessage: string;
  onRetry: () => void;
  onCancel: () => void;
}

const LoadingError: React.FC<LoadingErrorProps> = ({ errorMessage, onRetry, onCancel }) => {
  return (
    <div className="text-center space-y-6">
      <div className="flex justify-center">
        <GlassPill type="Error" variant="red" icon={<AlertTriangle />} className="text-base px-4 py-2">
          An Error Occurred
        </GlassPill>
      </div>
      <p className="text-muted-foreground">{errorMessage || 'Something went wrong during the process.'}</p>
      <div className="flex justify-center gap-4">
        <Button variant="outline" onClick={onCancel}>
          Close
        </Button>
        <Button onClick={onRetry} variant="default">
          <RefreshCw className="mr-2 h-4 w-4" />
          Try Again
        </Button>
      </div>
    </div>
  );
};

export default LoadingError;
